/**Calendar view to check the available announcements*/

import React, { useState, useEffect } from "react";
import { Search, ChevronLeft, ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getData } from "../../../../Services/ProfileServices";
import { getbarches, getallBanksByRole, getThemeURL } from "../../../../Services/EndPoints";
import { postDataWithBody } from "../../../../Services/Services";

const ScheduleAnnouncement = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedBranch, setSelectedBranch] = useState("All Branches");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const getCurrentDate = () => {
        const now = new Date();
        return {
            day: now.getDate(),
            month: now.getMonth(), // 0-11
            year: now.getFullYear(),
            hour: now.getHours(),
            minute: now.getMinutes()
        };
    };
    const currentDateInfo = getCurrentDate();
    const [selectedDate, setSelectedDate] = useState(currentDateInfo.day);
    const [selectedMonth, setSelectedMonth] = useState(currentDateInfo.month);
    const [selectedYear, setSelectedYear] = useState(currentDateInfo.year);
    const [showMonthDropdown, setShowMonthDropdown] = useState(false);
    const [showYearDropdown, setShowYearDropdown] = useState(false);
    const [viewStartDate, setViewStartDate] = useState(currentDateInfo.day);
    const getMonthName = (monthIndex) => {
        const months = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];
        return months[monthIndex];
    };
    const [selectedBank, setSelectedBank] = useState("All Banks");
    const years = [selectedYear - 1, selectedYear, selectedYear + 1];
    const getDaysInMonth = (month, year) => {
        return new Date(year, month + 1, 0).getDate();
    };
    const generateDates = (startDate) => {
        const dates = [];
        const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
        let currentDate = startDate;

        if (selectedMonth === currentDateInfo.month && selectedYear === currentDateInfo.year) {
            currentDate = Math.max(1, startDate - 2);
        }

        for (let i = 0; i < 11; i++) {
            dates.push({
                day: currentDate,
                month: selectedMonth,
                year: selectedYear
            });

            currentDate++;
            if (currentDate > daysInMonth) {
                currentDate = 1;
                const nextMonth = selectedMonth + 1 > 11 ? 0 : selectedMonth + 1;
                const nextYear = nextMonth === 0 ? selectedYear + 1 : selectedYear;
                dates[dates.length - 1].isLastDayOfMonth = true;
                dates.push({
                    day: currentDate,
                    month: nextMonth,
                    year: nextYear,
                    isFirstDayOfMonth: true
                });
                break;
            }
        }
        return dates;
    };
    const dates = generateDates(viewStartDate);
    const scheduleData = [
        {
            id: 1,
            title: "RBI Guidelines",
            branch: "Pandaul",
            startDate: 25,
            startTime: { hour: 9, minute: 0 },
            endDate: 28,
            endTime: { hour: 17, minute: 0 },
            completedDate: 28,
            completedTime: { hour: 17, minute: 0 }, // Fully completed
            color: "#5BC993",
            status: "Active"
        },
        {
            id: 2,
            title: "New Branch Openings",
            branch: "Pandaul",
            startDate: 27,
            startTime: { hour: 11, minute: 0 },
            endDate: 29,
            endTime: { hour: 16, minute: 0 },
            completedDate: 29, // Partially completed
            completedTime: { hour: 20, minute: 0 },
            color: "#5BC993",
            status: "Active"
        },
        {
            id: 3,
            title: "Shifting notice",
            branch: "Pandaul",
            startDate: 31,
            startTime: { hour: 10, minute: 0 },
            endDate: 2,
            endTime: { hour: 17, minute: 0 },
            completedDate: 31, // Partially completed
            completedTime: { hour: 15, minute: 0 },
            color: "#FF6584",
            status: "Inactive"
        },
        {
            id: 4,
            title: "New Accounts Guidelines",
            branch: "Pandaul",
            startDate: 26,
            startTime: { hour: 9, minute: 0 },
            endDate: 28,
            endTime: { hour: 17, minute: 0 },
            completedDate: 28, // Fully completed
            completedTime: { hour: 16, minute: 0 },
            color: "#457EFA",
            status: "Active"
        },
        {
            id: 5,
            title: "Revised Service Charges",
            branch: "Guthani",
            startDate: 27,
            startTime: { hour: 10, minute: 0 },
            endDate: 31,
            endTime: { hour: 17, minute: 0 },
            completedDate: 28, // Partially completed
            completedTime: { hour: 12, minute: 0 },
            color: "#FF6584",
            status: "Inactive"
        },
        {
            id: 6,
            title: "Shifting notice",
            branch: "Guthani",
            startDate: 31,
            startTime: { hour: 10, minute: 0 },
            endDate: 2,
            endTime: { hour: 17, minute: 0 },
            completedDate: 31, // Partially completed
            completedTime: { hour: 15, minute: 0 },
            color: "#FF6584",
            status: "Inactive"
        },
        {
            id: 7,
            title: "Amendment to service Charges",
            branch: "Ghogardiha",
            startDate: 25,
            startTime: { hour: 9, minute: 0 },
            endDate: 28,
            endTime: { hour: 17, minute: 0 },
            completedDate: 28, // Partially completed
            completedTime: { hour: 17, minute: 0 },
            color: "#5BC993",
            status: "Active"
        },
        {
            id: 8,
            title: "Revised Procedure for making e-payment",
            branch: "Ghogardiha",
            startDate: 26,
            startTime: { hour: 9, minute: 0 },
            endDate: 30,
            endTime: { hour: 17, minute: 0 },
            completedDate: 30, // Partially completed
            completedTime: { hour: 12, minute: 0 },
            color: "#457EFA",
            status: "Pause"
        },
        {
            id: 9,
            title: "Customer Service Improvement",
            branch: "Baisee",
            startDate: 26,
            startTime: { hour: 9, minute: 0 },
            endDate: 29,
            endTime: { hour: 17, minute: 0 },
            completedDate: 27, // Partially completed
            completedTime: { hour: 14, minute: 0 },
            color: "#FF6584",
            status: "Active"
        },
        {
            id: 10,
            title: "Digital Banking Training",
            branch: "Amour",
            startDate: 26,
            startTime: { hour: 11, minute: 0 },
            endDate: 28,
            endTime: { hour: 16, minute: 0 },
            completedDate: 28, // Partially completed
            completedTime: { hour: 10, minute: 0 },
            color: "#457EFA",
            status: "Active"
        }
    ];
    const [banksList, setBanksList] = useState([]);
    const [filteredBranches, setFilteredBranches] = useState([]);
    const [selectedBankId, setSelectedBankId] = useState("");
    const [validationErrors, setValidationErrors] = useState({});
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (selectedMonth !== currentDateInfo.month || selectedYear !== currentDateInfo.year) {
            setViewStartDate(1);
        } else {
            setViewStartDate(currentDateInfo.day);
        }
    }, [selectedMonth, selectedYear]);

    //To handle tab clicks between announcements and schedule
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    //month selection in drop down
    const toggleMonthDropdown = () => {
        setShowMonthDropdown(!showMonthDropdown);
        if (showYearDropdown) setShowYearDropdown(false);
    };

    // year drop down
    const toggleYearDropdown = () => {
        setShowYearDropdown(!showYearDropdown);
        if (showMonthDropdown) setShowMonthDropdown(false);
    };

    useEffect(() => {
        getUserProfile();
    }, []);

    const getUserProfile = async () => {
        try {
            const userProfile = await getData(getThemeURL);
            if (userProfile && userProfile.length > 0) {
                fetchBanks(userProfile[0]);
            }
        } catch (error) {
            console.error("Error fetching user profile:", error);
            toast.error("Failed to fetch user profile", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
            });
        }
    };

    const createPayload = (profile) => {
        let admin_role = "U"; // default value

        if (profile.role_name === "HO") {
            admin_role = "HO";
        } else if (profile.role_name === "SUPER ADMIN") {
            admin_role = "SA";
        }

        return {
            admin_role: admin_role,
            bank_id: profile.bank_id || null,
            branch_id: profile.branch_id || null
        };
    };

    // to fetch banks
    const fetchBanks = async (profile) => {
        try {
            const payload = createPayload(profile);
            const response = await postDataWithBody(getallBanksByRole, payload, {});
            if (response && Array.isArray(response)) {
                setBanksList(response);
                // Set default selected bank if available
                if (response.length > 0) {
                    setSelectedBank(response[0].bankName);
                    setSelectedBankId(response[0].id);
                    //fetchBranches(response[0].id);
                }
            } else {
                console.error("Invalid banks data format:", response);
                toast.error("Failed to load banks data");
            }
        } catch (error) {
            console.error("Error fetching banks:", error);
            toast.error("Failed to load banks data");
        }
    };

    //fetch branches based on bank selection
    const fetchBranches = async (bankId) => {
        try {
            const response = await getData(getbarches.replace("ID", bankId));
            if (response && Array.isArray(response)) {
                setFilteredBranches(response);
                // Reset selected branch when branches change
                setSelectedBranch("");
            } else {
                console.error(`Invalid branches data format for bank ${bankId}:`, response);
                setFilteredBranches([]);
            }
        } catch (error) {
            console.error(`Error fetching branches for bank ${bankId}:`, error);
            setFilteredBranches([]);
        }
    };

    const handleMonthSelect = (monthIndex) => {
        setSelectedMonth(monthIndex);
        setShowMonthDropdown(false);
    };

    const handleYearSelect = (year) => {
        setSelectedYear(year);
        setShowYearDropdown(false);
    };

    const navToCreateAnnouncement = () => {
        navigate("../create-announcement");
    };

    //Navigate to future days
    const navigateForward = () => {
        const daysInMonth = getDaysInMonth(selectedMonth, selectedYear);
        let newStartDate = viewStartDate + 5;
        if (newStartDate > daysInMonth) {
            newStartDate = Math.max(1, daysInMonth - 10);
        }
        setViewStartDate(newStartDate);
    };

    //Navigate to past days
    const navigateBackward = () => {
        let newStartDate = viewStartDate - 5;
        if (newStartDate < 1) {
            newStartDate = 1;
        }
        setViewStartDate(newStartDate);
    };

    //Handle data based on filters
    const handleDateSelect = (date) => {
        setSelectedDate(date.day);
    };

    const filteredSchedule = scheduleData.filter((item) => {
        if (activeTab !== "All" && item.status !== activeTab) return false;

        if (searchQuery && !item.title.toLowerCase().includes(searchQuery.toLowerCase())) return false;

        // Bank filtering
        if (selectedBankId && selectedBankId !== "") {
            const bankObject = banksList.find(b => b.id.toString() === selectedBankId.toString());
            if (!bankObject) return false; // Skip if bank not found
        }

        // Branch filtering - updated logic
        if (selectedBranch && selectedBranch !== "") {
            const branchObject = filteredBranches.find(b => b.id.toString() === selectedBranch.toString());
            if (!branchObject) return false;
            if (item.branch !== branchObject.branchName) return false;
        }

        return true;
    });


    const isToday = (date) => {
        return date.day === currentDateInfo.day &&
            date.month === currentDateInfo.month &&
            date.year === currentDateInfo.year;
    };

    const isSelected = (date) => date.day === selectedDate && date.month === selectedMonth && date.year === selectedYear;

    const getMaxAnnouncementsForBranch = (branch) => {
        const branchEvents = filteredSchedule.filter(item => item.branch === branch);

        const countByDay = {};

        branchEvents.forEach(event => {
            for (let day = event.startDate; day <= event.endDate; day++) {
                if (!countByDay[day]) countByDay[day] = 0;
                countByDay[day]++;
            }
        });

        return Math.max(1, ...Object.values(countByDay));
    };

    const handleBankChange = (e) => {
        const bankId = e.target.value;
        setSelectedBankId(bankId);
        setSelectedBank(bankId);
        setSelectedBranch('');
        console.log("bankId", bankId)

        if (bankId) {
            fetchBranches(bankId);
        } else {
            setFilteredBranches([]);
        }
    };

    const handleBranchChange = (e) => {
        const branchId = e.target.value;
        setSelectedBranch(branchId);
        // If no specific branch is selected (empty or "All"), filteredBranches will be shown as-is
    };


    return (
        <div className="main-container" style={{ backgroundColor: "white", padding: "0px" }}>
            {/* Header Tabs */}
            <div className="header-tabs" style={{
                display: "flex",
                marginBottom: "-5px",
                marginLeft: '-12px',
                marginRight: '-12px',
                backgroundColor: "white",
                padding: "8px 16px",
                borderRadius: "8px"
            }}>
                <div
                    className="tab"
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "transparent",
                        borderRadius: "8px",
                        color: "#809fb8",
                        fontWeight: "600",
                        marginRight: "10px",
                        fontSize: "15px",
                        cursor: "pointer"
                    }}
                    onClick={() => navigate("../public-announcements")}
                >
                    Public Announcements
                </div>
                <div
                    className="tab active"
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#e4f0f4",
                        borderRadius: "8px",
                        color: "#1a7a73",
                        fontWeight: "600",
                        fontSize: "15px",
                    }}
                >
                    Schedule
                </div>
                <div style={{ marginLeft: "auto" }}>
                    <button
                        onClick={navToCreateAnnouncement}
                        style={{
                            backgroundColor: "#2596be",
                            color: "white",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 15px",
                            marginTop: '5px',
                            cursor: "pointer",
                            fontWeight: "500"
                        }}
                    >
                        Create an Announcement
                    </button>
                </div>
            </div>

            {/* Content area with filters */}
            <div className="content-container" style={{
                backgroundColor: "#F9F9F9",
                borderRadius: "12px",
                padding: "10px"
            }}>
                {/* Filter Tabs */}
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "10px",
                    padding: "12px 16px",
                    flexWrap: "wrap"
                }}>
                    <div style={{
                        display: "flex",
                        backgroundColor: "white",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        overflow: "hidden"
                    }}>
                        {["All", "Active", "Inactive"].map((category, index) => (
                            <React.Fragment key={category}>
                                <button
                                    onClick={() => handleTabClick(category)}
                                    style={{
                                        padding: "5px 12px",
                                        border: "none",
                                        backgroundColor: activeTab === category ? "#2596be" : "white",
                                        color: activeTab === category ? "white" : "#666",
                                        cursor: "pointer",
                                        fontWeight: "500",
                                        fontSize: '12px',
                                        margin: "0"
                                    }}
                                >
                                    {category}
                                </button>
                                {index < 3 && (
                                    <div style={{
                                        width: "1px",
                                        margin: '3px',
                                        backgroundColor: "#e0e0e0"
                                    }} />
                                )}
                            </React.Fragment>
                        ))}
                    </div>

                    {/* Search Bar */}
                    <div style={{
                        width: windowWidth < 768 ? '200px' : '200px',
                        position: "relative"
                    }}>
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            padding: "0 10px",
                            backgroundColor: "white",
                            width: "100%",
                            boxSizing: "border-box"
                        }}>
                            <input
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{
                                    flex: 1,
                                    border: "none",
                                    outline: "none",
                                    padding: "4px 4px",
                                    fontSize: "14px",
                                    minWidth: "0"
                                }}
                            />
                            <Search size={18} color="#666" />
                        </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
                        <div style={{ position: "relative", marginTop: '14px' }}>
                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <select
                                        className={`form-select branch-input-form-control ${validationErrors.bank ? "is-invalid" : ""}`}
                                        id="bank"
                                        value={selectedBank}
                                        onChange={handleBankChange}
                                        required
                                        style={{ height: '35px', fontSize: '13px' }}
                                    >

                                        <option value="">Select Bank</option>
                                        {banksList.map((bank) => (
                                            <option key={bank.id} value={bank.id}>
                                                {bank.bankName}
                                            </option>
                                        ))}
                                    </select>
                                    {validationErrors.bank && (
                                        <div className="invalid-feedback">
                                            {validationErrors.bank}
                                        </div>
                                    )}
                                </div>

                                <div className="col-md-6">
                                    <select
                                        className={`form-select branch-input-form-control ${validationErrors.branch ? "is-invalid" : ""}`}
                                        id="branch"
                                        value={selectedBranch}
                                        onChange={handleBranchChange}
                                        required
                                        style={{ marginLeft: '-15px', height: '35px', fontSize: '13px' }}
                                    >

                                        <option value="">All Branches</option>
                                        {filteredBranches.map((branch) => (
                                            <option key={branch.id} value={branch.id}>
                                                {branch.branchName}
                                            </option>
                                        ))}
                                    </select>
                                    {validationErrors.branch && (
                                        <div className="invalid-feedback">
                                            {validationErrors.branch}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>


                    </div>

                    <div style={{ position: "relative", marginLeft: "auto", display: "flex", alignItems: "center" }}>
                        <span style={{ fontSize: "14px", marginRight: "8px" }}>Period:</span>

                        <div style={{ position: "relative", marginRight: "8px" }}>
                            <button
                                onClick={toggleMonthDropdown}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "5px 12px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    backgroundColor: "white",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    minWidth: "110px"
                                }}
                            >
                                {getMonthName(selectedMonth)} <span style={{ marginLeft: "5px" }}>▼</span>
                            </button>
                            {showMonthDropdown && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "100%",
                                        right: 0,
                                        width: "150px",
                                        backgroundColor: "white",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        zIndex: 10,
                                        maxHeight: "200px",
                                        overflowY: "auto"
                                    }}
                                >
                                    {Array.from({ length: 12 }, (_, i) => i).map((monthIndex) => (
                                        <div
                                            key={monthIndex}
                                            onClick={() => handleMonthSelect(monthIndex)}
                                            style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                backgroundColor: selectedMonth === monthIndex ? "#f0f0f0" : "transparent"
                                            }}
                                        >
                                            {getMonthName(monthIndex)}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Year Dropdown */}
                        <div style={{ position: "relative" }}>
                            <button
                                onClick={toggleYearDropdown}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "5px 12px",
                                    border: "1px solid #ddd",
                                    borderRadius: "4px",
                                    backgroundColor: "white",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    minWidth: "80px"
                                }}
                            >
                                {selectedYear} <span style={{ marginLeft: "5px" }}>▼</span>
                            </button>
                            {showYearDropdown && (
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "100%",
                                        right: 0,
                                        width: "100px",
                                        backgroundColor: "white",
                                        border: "1px solid #ddd",
                                        borderRadius: "5px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        zIndex: 10
                                    }}
                                >
                                    {years.map((year) => (
                                        <div
                                            key={year}
                                            onClick={() => handleYearSelect(year)}
                                            style={{
                                                padding: "8px 12px",
                                                cursor: "pointer",
                                                backgroundColor: selectedYear === year ? "#f0f0f0" : "transparent"
                                            }}
                                        >
                                            {year}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Calendar View with Navigation */}
                <div style={{
                    backgroundColor: "white",
                    borderRadius: "8px",
                    padding: "10px",
                    overflowX: "auto"
                }}>
                    {/* Month Navigation controls */}
                    {/* <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px"
          }}>
            <button 
              onClick={navigateToPrevMonth}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 12px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "white",
                cursor: "pointer"
              }}
            >
              <ChevronLeft size={16} />
              <span style={{ marginLeft: "4px" }}>Previous Month</span>
            </button>
            
            <div style={{ 
              fontWeight: "bold", 
              fontSize: "16px",
              alignItems: "center",
            }}>
              {getMonthName(selectedMonth)} {selectedYear}
            </div>
            
            <button 
              onClick={navigateToNextMonth}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "6px 12px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                backgroundColor: "white",
                cursor: "pointer"
              }}
            >
              <span style={{ marginRight: "4px" }}>Next Month</span>
              <ChevronRight size={16} />
            </button>
          </div> */}

                    {/* Date Navigation controls */}
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px"
                    }}>
                        <button
                            onClick={navigateBackward}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "white",
                                cursor: "pointer"
                            }}
                        >
                            <ChevronLeft size={16} />
                            <span style={{ marginLeft: "4px" }}>Previous Days</span>
                        </button>
                        <div style={{
                            fontWeight: "bold",
                            fontSize: "16px",
                        }}>
                            {getMonthName(selectedMonth)} {selectedYear}
                        </div>
                        <button
                            onClick={navigateForward}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "white",
                                cursor: "pointer"
                            }}
                        >
                            <span style={{ marginRight: "4px" }}>Next Days</span>
                            <ChevronRight size={16} />
                        </button>
                    </div>

                    <div style={{
                        display: "grid",
                        gridTemplateColumns: `150px repeat(${dates.length}, minmax(60px, 1fr))`,
                        minWidth: windowWidth < 768 ? "800px" : "auto",
                        border: "1px solid #eaeaea",
                        borderRadius: "4px",
                        position: "relative"
                    }}>
                        {/* Calendar Header - Dates */}
                        <div style={{
                            backgroundColor: "#f9f9f9",
                            padding: "12px 8px",
                            fontWeight: "bold",
                            textAlign: "center",
                            borderBottom: "1px solid #eaeaea",
                            borderRight: "1px solid #eaeaea"
                        }}>
                            Branches
                        </div>

                        {dates.map((date, index) => {
                            return (
                                <div
                                    key={`${date.day}-${date.month}-${date.year}-${index}`}
                                    onClick={() => handleDateSelect(date)}
                                    style={{
                                        backgroundColor: isSelected(date) ? "#f0f7ff" : "#f9f9f9",
                                        padding: "12px 8px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        borderBottom: "1px solid #eaeaea",
                                        borderRight: "1px solid #eaeaea",
                                        position: "relative",
                                        cursor: "pointer"
                                    }}
                                >
                                    {date.isFirstDayOfMonth && (
                                        <div style={{
                                            position: "absolute",
                                            top: "0px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            fontSize: "10px",
                                            color: "#666",
                                            fontWeight: "normal"
                                        }}>
                                            {getMonthName(date.month).substring(0, 3)}
                                        </div>
                                    )}
                                    {date.day}
                                    {isToday(date) && (
                                        <div style={{
                                            position: "absolute",
                                            top: "4px",
                                            right: "2px",
                                            backgroundColor: "#457EFA",
                                            color: "white",
                                            fontSize: "8px",
                                            padding: "2px 4px",
                                            borderRadius: "4px"
                                        }}>
                                            Today
                                        </div>
                                    )}
                                    {isSelected(date) && (
                                        <div style={{
                                            position: "absolute",
                                            bottom: "-1px",
                                            left: "0",
                                            width: "100%",
                                            height: "3px",
                                            backgroundColor: "#457EFA"
                                        }} />
                                    )}
                                </div>
                            );
                        })}

                        {/* Blue indicator*/}
                        {/* {branches.filter(branch => selectedBranch === "All Branches" || branch === selectedBranch || branch === "All Branches").map((branch, branchIndex) => {
              const selectedDateIndex = dates.findIndex(date => 
                date.day === selectedDate && 
                date.month === selectedMonth && 
                date.year === selectedYear
              );
              
              if (selectedDateIndex === -1) return null;
              
              return (
                <div
                  key={`indicator-${branch}`}
                  style={{
                    position: "absolute",
                    top: "41px", // Start below the header row
                    left: `calc(150px + ${selectedDateIndex} * (100% - 150px) / ${dates.length})`,
                    width: "3px",
                    height: `calc(100% - 41px)`,
                    backgroundColor: "#457EFA",
                    zIndex: "1",
                    pointerEvents: "none" 
                  }}
                />
              );
            })} */}


                        {/* Calendar Body - Branch rows and schedule items */}
                        {filteredBranches.length > 0 ? (
                            // Only show branches that match the selected branch or all if none selected
                            filteredBranches
                                .filter(branch => !selectedBranch || selectedBranch === "" || branch.id.toString() === selectedBranch.toString())
                                .map((branch, index) => {
                                    const maxAnnouncements = getMaxAnnouncementsForBranch(branch.branchName);
                                    const rowHeight = Math.max(40, maxAnnouncements * 30);
                                    return (
                                        <React.Fragment key={branch.id}>
                                            {/* Branch Name Column */}
                                            <div style={{
                                                padding: "10px",
                                                borderBottom: index < filteredBranches.length - 1 ? "1px solid #eaeaea" : "none",
                                                borderRight: "1px solid #eaeaea",
                                                fontWeight: "500",
                                                height: `${rowHeight + 70}px`
                                            }}>
                                                {branch.branchName}
                                            </div>

                                            {/* Schedule Cells for each date */}
                                            {renderScheduleBars(branch.branchName, dates, filteredSchedule, index < filteredBranches.length - 1, isSelected, isToday, rowHeight)}
                                        </React.Fragment>
                                    );
                                })
                        ) : (
                            <div style={{
                                padding: "20px",
                                textAlign: "center",
                                gridColumn: "span " + (dates.length + 1)
                            }}>
                                No branches available for the selected bank
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    );

    //UI to render the scheduled bars on calendar view
    function renderScheduleBars(branch, dates, scheduleItems, hasBottomBorder, isSelected, isToday, rowHeight) {
        // Find the branch object to get the exact branch name
        const branchObj = filteredBranches.find(b => b.id.toString() === branch.toString());
        const branchName = branchObj ? branchObj.branchName : branch;

        const branchEvents = scheduleItems.filter(item => item.branch === branchName);
        const occupiedRows = {};
        const renderedEvents = new Set();

        // Rest of the function remains the same...
        return dates.map((date, colIndex) => {
            const eventsForDate = branchEvents.filter(
                event => date.day >= event.startDate && date.day <= event.endDate
            );

            return (
                <div
                    key={`${branch}-${date.day}-${date.month}-${date.year}-${colIndex}`}
                    style={{
                        padding: "5px",
                        borderBottom: hasBottomBorder ? "1px solid #eaeaea" : "none",
                        borderRight: "1px solid #eaeaea",
                        height: `${rowHeight + 70}px`,
                        backgroundColor: isSelected(date) ? "rgba(73, 156, 230, 0.05)" :
                            isToday(date) ? "rgba(73, 156, 230, 0.02)" : "white",
                        position: "relative"
                    }}
                >
                    {eventsForDate.map((event, eventIndex) => {
                        if (renderedEvents.has(event.id)) {
                            return null;
                        }
                        if (date.day === event.startDate) {
                            const endDateIndex = dates.findIndex((d, i) =>
                                i >= colIndex && d.day === event.endDate && d.month === date.month
                            );
                            const span = endDateIndex !== -1 ?
                                endDateIndex - colIndex + 1 :
                                dates.length - colIndex;
                            let rowPosition = 0;
                            while (occupiedRows[`${colIndex}-${rowPosition}`]) {
                                rowPosition++;
                            }
                            for (let i = 0; i < span; i++) {
                                occupiedRows[`${colIndex + i}-${rowPosition}`] = true;
                            }
                            renderedEvents.add(event.id);
                            const completionDateIndex = dates.findIndex((d, i) =>
                                i >= colIndex &&
                                d.day === event.completedDate &&
                                (d.month === date.month || (d.month > date.month && d.day < event.startDate))
                            );

                            const completionRatio = completionDateIndex !== -1 ?
                                (completionDateIndex - colIndex + 1) / span :
                                1;

                            let timeAdjustedCompletionRatio = completionRatio;
                            if (completionDateIndex !== -1 && event.completedDate === dates[completionDateIndex].day) {
                                // within the day (0.0 to 1.0)
                                const dayStartTime = 9; // 9:00 AM
                                const dayEndTime = 17; // 5:00 PM
                                const totalDayHours = dayEndTime - dayStartTime;

                                const completedHours = event.completedTime.hour + (event.completedTime.minute / 60) - dayStartTime;
                                const timeRatio = Math.max(0, Math.min(1, completedHours / totalDayHours));

                                if (completionRatio === 1) {
                                    timeAdjustedCompletionRatio = (span - 1 + timeRatio) / span;
                                } else if (completionDateIndex === colIndex) {
                                    timeAdjustedCompletionRatio = timeRatio;
                                }
                            }


                            const topPosition = 8 + (rowPosition * 46);

                            return (
                                <div
                                    key={event.id}
                                    style={{
                                        position: "absolute",
                                        left: "5px",
                                        top: `${topPosition}px`,
                                        height: "36px",
                                        width: `calc(${span * 100}% - 10px)`,
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        cursor: "pointer"
                                    }}
                                >
                                    {/* Background bar (full length but with reduced opacity) */}
                                    <div style={{
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: event.color,
                                        opacity: 0.3,
                                        borderRadius: "4px"
                                    }} />

                                    {/* Completed portion (full opacity) */}
                                    <div style={{
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        width: `${timeAdjustedCompletionRatio * 100}%`,
                                        height: "100%",
                                        backgroundColor: event.color,
                                        borderRadius: timeAdjustedCompletionRatio === 1 ? "4px" : "4px 0 0 4px",
                                        zIndex: 1
                                    }} />

                                    {timeAdjustedCompletionRatio < 1 && (
                                        <div style={{
                                            position: "absolute",
                                            left: `${timeAdjustedCompletionRatio * 100}%`,
                                            top: 0,
                                            width: `${(1 - timeAdjustedCompletionRatio) * 100}%`,
                                            height: "100%",
                                            backgroundColor: "#DEDEDE",
                                            borderRadius: timeAdjustedCompletionRatio === 0 ? "4px" : "0 4px 4px 0",
                                            zIndex: 1
                                        }} />
                                    )}

                                    <div style={{
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        color: "black",
                                        fontSize: "12px",
                                        zIndex: 2,
                                        padding: "0 8px",
                                        boxSizing: "border-box",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontWeight: 500,

                                    }}>
                                        {event.title}
                                    </div>
                                </div>
                            );
                        }

                        return null;
                    })}
                </div>
            );
        });
    }
}
export default ScheduleAnnouncement;